import { useQuery } from '@tanstack/react-query';

import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';
import { getProjectPlanUsageCounts } from '@/features/subscriptions/api/get-project-plan-usage-counts';

export const PROJECT_PLAN_USAGE_COUNTS_QUERY_KEY = 'project-plan-usage-counts';

export function useProjectPlanUsageCounts() {
  const orgId = useCurrentOrgId();

  return useQuery({
    queryKey: [PROJECT_PLAN_USAGE_COUNTS_QUERY_KEY, orgId],
    queryFn: () => getProjectPlanUsageCounts(orgId ?? 0),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
